import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const SEOSettingsSource = {
  fetch: function() {
    return axios.get(`${API_BASE}/seo_settings`)
      .then(resp => resp.data)
  },
  update: function(settings) {
    return axios.post(`${API_BASE}/seo_settings`, settings)
      .then(resp => resp.data)
  }
}

export default SEOSettingsSource



// WEBPACK FOOTER //
// ./app/sources/SEOSettingsSource.js